import { ActionsUnion, createAction } from 'app/shared/utils/action-helpers';

// Models
import {
  EventActionTypes,
  EventEditRequest,
} from 'app/shared/eventsOld/models';
import { GetActionEventsPayload } from 'app/modules/actionEvents/requests';
import { GetActionEventsResponse } from 'app/modules/actionEvents/responses';

export const editEvent = (payload: EventEditRequest) => {
  return createAction(EventActionTypes.EDIT_EVENT, payload);
};

export const editEventSuccess = (payload) => {
  return createAction(EventActionTypes.EDIT_EVENT_SUCCESS, payload);
};

export const retrieveActionEvents = (payload: GetActionEventsPayload) => {
  return createAction(EventActionTypes.RETRIEVE_ACTION_EVENTS, payload);
};

export const retrieveActionEventsSuccess = (
  payload: GetActionEventsResponse,
) => {
  return createAction(EventActionTypes.RETRIEVE_ACTION_EVENTS_SUCCESS, payload);
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const EventsActionsList = {
  editEvent,
  editEventSuccess,
  retrieveActionEventsSuccess,
};

export type EventsActions = ActionsUnion<typeof EventsActionsList>;
